import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { Problem } from './components/Problem';
import { Modules } from './components/Modules';
import { Bonuses } from './components/Bonuses';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { Offer } from './components/Offer';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-legal-900 text-slate-50 font-sans selection:bg-gold-500/30" data-id="element-0" data-mp="2mjzlp1wudjkz">
      <MetaPixel data-id="element-1" data-mp="31cjn9y4cfj0b" />
      <main data-id="element-2" data-mp="2wka0us2ft12s">
        <Hero data-id="element-3" data-mp="2wjgptewg3peu" />
        <StatsBar data-id="element-4" data-mp="2wiyxgtcwlvc7" />
        <Problem data-id="element-5" data-mp="2wifgbev2vaz8" />
        <Modules data-id="element-6" data-mp="2whxb3sqftmf6" />
        <Bonuses data-id="element-7" data-mp="28ufo0ai4bcij" />
        <Testimonials data-id="element-8" data-mp="28tw4wqgqei2x" />
        <Guarantee data-id="element-9" data-mp="28te3zgj4jfoo" />
        <Offer data-id="element-10" data-mp="28sl3gxardmez" />
        <FinalCTA data-id="element-11" data-mp="28sbe9bxjfjac" />
      </main>
      <Footer data-id="element-12" data-mp="23vune9yyeqtk" />
    </div>;
}